import { calculatePricingFormTotalPrice } from '../components/form/utils';
import { CartItem } from '../state/types';
import { getQuantityFromItem } from '../state/utils';

export const calculateTotalPrice = (cart: CartItem[], taxRate: number | null): number =>
  cart.reduce((prev, curr) => {
    if (curr.type === 'service') {
      return prev + getQuantityFromItem(curr) * (curr.service.totalPrice || 0);
    }
    if (curr.type === 'pricing-form') {
      const cost = calculatePricingFormTotalPrice(curr.pricingForm, curr.values);

      const tax = curr.pricingForm.taxable && taxRate ? (cost * (taxRate * 100)) / 100 : 0;
      const costWithTax = cost + tax;

      return prev + costWithTax;
    }
    return prev;
  }, 0);

export const calculateSubTotalPrice = (cart: CartItem[]): number =>
  cart.reduce((prev, curr) => {
    if (curr.type === 'service') {
      return prev + getQuantityFromItem(curr) * (curr.service.price || 0);
    }
    if (curr.type === 'pricing-form') {
      return prev + calculatePricingFormTotalPrice(curr.pricingForm, curr.values);
    }
    return prev;
  }, 0);
